<template>
    <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{$t('category.form.information')}} </h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-12">
              <TextField 
                :placeholder="$t('category.form.name.placeholder')"
                :label="$t('category.form.name.label')"
                v-model="model.name"
              />
            </div>

          </div>
          
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [ FormMixin ],
  components: {
    TextField: () => import('@components/form2/textfield')
  },
  data () {
    return {
      model:{
        name: '',
        remarks: '',
      },
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  computed: {
    categoryID() {
      let parameters = this.parameters || {}
      return parameters.categoryID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.categoryID

      return this.$store.dispatch('category/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    categoryID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.categoryID) {
      this.fetchData()
    }
  }
}
</script>